/**
 * Stripe.js (~290 Ko compressés, iframe anti-fraude) : téléchargé SEULEMENT
 * là où on paie.
 *
 * On importe @stripe/stripe-js par son entrée « pure » : le script n'est
 * injecté qu'au premier appel de loadStripe. L'entrée par défaut l'injecte
 * dès que le module est évalué ; comme la page de paiement est dans le
 * fichier principal, CHAQUE page publique (/c/:id, /fete, accueil…)
 * téléchargeait Stripe.js et ouvrait son iframe, pour rien.
 *
 * `chargerStripe` garde UNE promesse par clé (recommandation de Stripe : ne
 * pas recréer l'objet Stripe à chaque affichage). La page de paiement
 * l'appelle dès qu'elle connaît la clé publique : le script arrive pendant
 * que le donateur choisit son montant, prêt au moment de payer.
 */
import { loadStripe } from "@stripe/stripe-js/pure";

const promesses = new Map();

export function chargerStripe(clePublique) {
  if (!promesses.has(clePublique)) {
    const promesse = loadStripe(clePublique);
    // Échec (bloqueur, réseau) : on oublie la promesse, le prochain appel
    // retentera le chargement.
    promesse.catch(() => promesses.delete(clePublique));
    promesses.set(clePublique, promesse);
  }
  return promesses.get(clePublique);
}
